import React from 'react';

// Función auxiliar para convertir coordenadas polares a cartesianas para SVG
const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
};

const StatisticsPieChart = ({ title, data }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  let currentAngle = 0; // Ángulo inicial para dibujar los segmentos

  const slices = data.map((item, index) => {
    if (item.value === 0) return null; // No dibujar segmentos con valor cero

    const sliceAngle = (item.value / total) * 360; // Ángulo del segmento
    const startAngle = currentAngle;
    const endAngle = currentAngle + sliceAngle;

    const start = polarToCartesian(50, 50, 40, startAngle); // Punto de inicio del arco
    const end = polarToCartesian(50, 50, 40, endAngle); // Punto final del arco

    const largeArcFlag = sliceAngle > 180 ? 1 : 0; // Para arcos grandes o pequeños

    // Construcción del path SVG para el segmento del pastel
    const pathData = [
      `M 50 50`, // Mover al centro del círculo
      `L ${start.x} ${start.y}`, // Línea desde el centro al punto de inicio del arco
      `A 40 40 0 ${largeArcFlag} 1 ${end.x} ${end.y}`, // Arco (radioX, radioY, rotación, largeArcFlag, sweepFlag, endX, endY)
      `Z` // Cerrar el camino de vuelta al centro
    ].join(' ');

    currentAngle = endAngle; // Actualizar el ángulo para el siguiente segmento

    return (
      <path
        key={index}
        d={pathData}
        fill={item.hexColor} // Color de relleno del segmento
        className="transition-all duration-500 ease-out"
      />
    );
  }).filter(Boolean); // Filtrar los segmentos nulos (valores 0)

  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg">
      <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{title}</h3>
      {data.length === 0 || total === 0 ? (
        <p className="text-gray-500 text-center py-4 text-base">No hay datos para mostrar.</p>
      ) : (
        <div className="flex flex-col items-center">
          <svg viewBox="0 0 100 100" className="w-40 h-40 mb-4"> {/* Tamaño del SVG ajustado */}
            {slices}
            {/* Círculo central para un efecto más pulcro */}
            <circle cx="50" cy="50" r="25" fill="white" />
            {/* Texto central opcional, si se desea mostrar el total o un label */}
            <text x="50" y="55" textAnchor="middle" fontSize="10" fill="#333" fontWeight="bold">
              {total}
            </text>
          </svg>
          <ul className="space-y-2 w-full">
            {data.map((item, index) => (
              <li key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                <div className="flex items-center space-x-2">
                  <span className={`w-4 h-4 rounded-full ${item.colorClass}`}></span> {/* Usar colorClass para la leyenda */}
                  <span className="text-base font-medium text-gray-700">{item.label}</span>
                </div>
                <span className="text-base font-semibold text-gray-900">
                  {total > 0 ? `${((item.value / total) * 100).toFixed(1)}%` : '0%'} ({item.value})
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default StatisticsPieChart;